/*eslint-disable */
import toast from '@/services/toast';
import Multiselect from 'vue-multiselect'
import {
  bus
} from '@/main';
export default {
  name: 'todo-app',
  components: {Multiselect},
  props: ['sharedToDoDATA'],
  data () {
    return {
      submitted:false,
      userList:null,
      userListResults:[], 
      options:[],
      name:'',
      sentUserData:[],
      users:[],
      sharedToDoId:'',
      selection_type:'User',
      groupUserList:null,
      groupUserListResults:[],
      groupOptions:[]
    }
  },
  computed: {

  },
  mounted () {
    this.getAllUserListMethod()
    this.name = this.sharedToDoDATA.title
    this.sharedToDoId = this.sharedToDoDATA.id
  },
  methods: {
    selectedOptionMethod(item){
      this.users = []
      this.sentUserData = []
      this.$validator.reset()
      this.selection_type = item
      if(item === 'User') return
      if(this.groupUserList) return;
      this.$store.dispatch('getGroupChatRoomCreatedFun').then((res) => {
        this.groupUserList = res.data.data
        if(this.groupUserList != undefined){
          this.groupUserListResults = this.groupUserList
          for(var i = 0; i < this.groupUserListResults.length; i++){
            this.groupOptions.push({gName:this.groupUserListResults[i].name, id : this.groupUserListResults[i].id})
          }
        }
      })
    },
    getAllUserListMethod() {
     this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
       this.userList = res.data.data
       if(this.userList != undefined){
         this.userListResults = this.userList
         for(var i = 0; i < this.userListResults.length; i++){
           this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
         }
       }
     }).catch((err)=>{})
    },
    customGroupLabel ({ gName }) {
      return `${gName}`
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    sharedNotesMethod(){
      this.sentUserData = []
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          if(this.selection_type === 'User'){
            for(var i = 0; i < this.users.length; i++){
              this.sentUserData.push(this.users[i].id)
            }
            var data = {
              todo_id:this.sharedToDoId,
              to_user_id:this.sentUserData
            }
            this.$store.dispatch('shareToDoWithUserAction', data)
              .then((res) => { 
                toast.success(res.data.msg);
                this.submitted =  false
                this.sharedNotesPopupDisabledFun()
              }).catch((err) => {
                toast.error(err.data.msg);
                this.submitted =  false
              })
              return;
          }else{
            var data = {
              todo_id:this.sharedToDoId,
              to_user_id:this.users.id
            }
            this.$store.dispatch('shareToDoWithUserAction', data)
              .then((res) => { 
                toast.success(res.data.msg);
                this.submitted =  false
                this.sharedNotesPopupDisabledFun()
              }).catch((err) => {
                toast.error(err.data.msg);
                this.submitted =  false
              })
              return;
          }
        }
      })
    },
    sharedNotesPopupDisabledFun(){
      document.body.classList.remove('body_right_scroll_remove')
      bus.$emit('sharedToDoStateBus', false);
      this.sentUserData = []
      this.sharedToDoId = ''
      this.name = ''
    }
  }
}